import React from "react";
import { Link } from "react-router-dom";
import isURL from "validator/lib/isURL";

interface IProps {
  url: string;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  target?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement | HTMLAnchorElement>;
  onMouseOver?: React.MouseEventHandler<HTMLDivElement | HTMLAnchorElement>;
  onMouseOut?: React.MouseEventHandler<HTMLDivElement | HTMLAnchorElement>;
}

const UiKitUtilsLink = ({ url, children, target, ...props }: IProps) => {
  if (url) {
    const rel = target === "_blank" ? "noopener noreferrer" : undefined;
    if (isURL(url)) {
      return (
        <a href={url} target={target} rel={rel} {...props}>
          {children}
        </a>
      );
    }
    return (
      <Link to={url} target={target} rel={rel} {...props}>
        {children}
      </Link>
    );
  }
  return <div {...props}>{children}</div>;
};

export default UiKitUtilsLink;
